import { createElementBlock as o, openBlock as e, createElementVNode as r } from "vue";
import l from "./index289.js";
const a = {}, n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function s(c, t, p, f, m, i) {
  return e(), o("svg", n, t[0] || (t[0] = [
    r("path", {
      fill: "currentColor",
      d: "m15.31 7.926 5.782.722.07.012a.75.75 0 0 1 .373 1.256l-4.111 4.205 1.132 5.734.01.066a.75.75 0 0 1-1.068.756L12 18.065l-5.5 2.612-.061.027a.75.75 0 0 1-.996-.85l1.133-5.733-4.112-4.205-.047-.052a.75.75 0 0 1 .49-1.216l5.782-.722 2.64-5.262a.75.75 0 0 1 1.341 0l2.642 5.262ZM12 4.671c-.062 7.877-.067 11.815-.015 11.814a.75.75 0 0 1 .336.073l4.474 2.124-.92-4.657-.011-.08a.75.75 0 0 1 .21-.59l3.332-3.406-4.679-.584a.75.75 0 0 1-.577-.408L12 4.671Z"
    }, null, -1)
  ]));
}
const u = /* @__PURE__ */ l(a, [["render", s]]);
export {
  u as default
};
